import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Sidebar from './Sidebar';

export default function DashboardLayout() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { i18n } = useTranslation();
  const isRTL = i18n.dir() === 'rtl';

  return (
    <div className="h-screen bg-background text-foreground transition-colors duration-300 overflow-hidden">
      <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
      
      {/* Main content with dynamic margin - RTL support */}
      <div className={`h-screen transition-all duration-300 ease-in-out ${
        isRTL 
          ? (isCollapsed ? 'lg:mr-[68px]' : 'lg:mr-64')
          : (isCollapsed ? 'lg:ml-[68px]' : 'lg:ml-64')
      }`}>
        <div className="flex flex-col h-full">
          {/* Mobile header spacer */}
          <div className="h-12 lg:hidden" />
          
          {/* Page content */}
          <main className="flex-1 p-4 lg:p-6 flex flex-col min-h-0 overflow-y-auto">
            <div className="mx-auto w-full min-h-0 flex-1 flex flex-col">
              <Outlet />
            </div>
          </main>
          
          {/* Footer */}
          <footer className="border-t border-border bg-card shadow-soft-lg py-6">
            <div className="max-w-7xl mx-auto px-4 lg:px-6">
              <div className="flex flex-col sm:flex-row items-center justify-between">
                <p className="text-sm text-muted-foreground">
                  © 2025 Doctif. Professional Dental Practice Management.
                </p>
                <div className="flex items-center space-x-4 mt-2 sm:mt-0">
                  <span className="text-xs text-muted-foreground">
                    Version 2.1.0
                  </span>
                  <div className="h-4 w-px bg-border" />
                  <span className="text-xs font-medium text-status-success">
                    System Healthy
                  </span>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
}
